<template>
  <donut-chart34-template
    :board-ids="[481]"
    :data-type="dataType"
    field-code="facility-public"
    :graph-id="75"
    title="(공중(다중)이용시설)안전·보건 확보 의무 현황"
    unit="건"
    :orientation="orientation"
  />
</template>

<script>
/* eslint-disable brace-style */
import DonutChart34Template from "@/views/graph/DonutChart34Template.vue";

export default {
  name: 'DonutChart75',
  components: {DonutChart34Template},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
}
</script>

<style scoped>

</style>
